<template>
  <div class="classes-detail-recommend">
    <div class="classes-detail-recommend-header bold5">推荐班级</div>
    <div v-if="recommendList.length > 0">
      <ClassesDetailItem
        class="classes-detail-recommend-item"
        v-for="item in recommendList"
        :key="item.id"
        :item="item"
        :isUnderlineLeft="false"
      ></ClassesDetailItem>
    </div>
    <div class="classes-detail-recommend-empty" v-else>
      <EmptySmall title="暂无推荐班级"></EmptySmall>
    </div>
  </div>
</template>
<script>
import ClassesDetailItem from "./ClassesDetailItem.vue";
import EmptySmall from "@/components/EmptySmall.vue";

export default {
  name: "ClassesDetailRecommend",
  components: { ClassesDetailItem, EmptySmall },
  props: {
    recommendList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="scss" scoped>
.classes-detail-recommend {
  width: 296px;
}
.classes-detail-recommend-header {
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Medium;
  line-height: 24px;
  padding: 16px;
  background: white;
  border-radius: 4px;
}
.classes-detail-recommend-item {
  width: 100%;
  margin: 24px 0 0 0;

  /deep/ {
    .classes-item {
      border-radius: 4px;
    }
    .classes-cover {
      width: 296px;
      height: 198px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    .classes-item-course_count {
      top: 164px;
      right: 8px;
    }
    .classes-subtitle {
      display: none;
    }
    .classes-title {
      margin-bottom: 16px;
      font-family: PingFangSC, PingFangSC-Regular;
    }
    .classes-bottom {
      display: block;
    }
    .classes-sales-price {
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: center;
    }
    .classes-sales {
      margin: 0;
    }
    .classes-sales {
      color: #666;
      opacity: 0.9;
      line-height: 24px;
    }
    .price-underline {
      margin: 0 0 0 8px;
    }
  }
}
.classes-detail-recommend-empty {
  background: white;
  margin-top: 24px;
  padding: 78px 0 83px 0;
}
</style>
